document.addEventListener("DOMContentLoaded", function () {
  document.addEventListener("click", function (e) {
    const selector = "[data-accordion-trigger]";
    let trigger;
    if (e.target.matches(selector) || (trigger = e.target.closest(selector))) {
      trigger = trigger || e.target;
      const accordion = document.querySelector(
        `[data-accordion="${trigger.dataset.accordionTrigger}"]`
      );

      if (accordion) {
        accordion.classList.toggle("is-open");
        trigger.classList.toggle("is-open");
        trigger.setAttribute(
          "aria-expanded",
          trigger.classList.contains("is-open") ? "true" : "false"
        );
      }
    }
  });
});

window.Undo = function() {
  return {
    action: () => {},
    onReset: () => {},
    remove () {
      const container = document.querySelector(`[data-undo="${this.id}"]`).parentElement;
      if (container) container.remove();
    },
    reset() {
      this.onReset();
      this.remove();
      this.action = () => {};
    },
    id: Math.random().toString(16).substring(2),
    activateAt(el, classes = '', text = "undo bundle removal", period = 10000000) {
      setTimeout(() => {
        this.reset()
      }, period);
      const btnContainer = document.createElement("div");
      btnContainer.className = "undo-container";
      btnContainer.innerHTML = `<button type="button" class="undo-button ${classes}" data-undo="${this.id}">${text}</button>`;
      el.appendChild(btnContainer);
      document
        .querySelector(`[data-undo="${this.id}"]`)
        .addEventListener("click", this.action);
    },

    activateAfterEl(el, classes = '', text = "undo bundle removal", period = 10000) {
      setTimeout(() => {
        this.reset();
      }, period);
      const btnContainer = document.createElement("div");
      btnContainer.className = "undo-container";
      btnContainer.innerHTML = `<button type="button" class="undo-button ${classes}" data-undo="${this.id}">${text}</button>`;
      el.insertAdjacentElement('afterend', btnContainer);
      document
        .querySelector(`[data-undo="${this.id}"]`)
        .addEventListener("click", this.action);
    },
  }
};
